// src/components/layout/SectionNavigator.tsx
import React from 'react';

interface Section {
  id: string;
  title: string;
  level: number;
}

interface SectionNavigatorProps {
  sections: Section[];
  activeSection?: string;
}

const SectionNavigator: React.FC<SectionNavigatorProps> = ({ sections, activeSection }) => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="">
      <nav className="space-y-3 font-mono text-xs">
        {sections.map((section) => (
          <button
            key={section.id}
            onClick={() => scrollToSection(section.id)}
            className={`block w-full text-left transition-colors hover:text-foreground ${
              section.level === 1
                ? 'font-bold uppercase tracking-wider text-foreground'
                : section.level === 2
                ? 'text-muted-foreground hover:text-foreground ml-2'
                : 'text-muted-foreground hover:text-foreground ml-4'
            } ${
              activeSection === section.id ? 'text-foreground font-bold underline decoration-2 underline-offset-4' : ''
            }`}
          >
            {section.level > 1 && <span className="mr-2 opacity-50">↳</span>}
            {section.title}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default SectionNavigator;
